<div class="sac-transports"
  [ngStyle]="{ 'width.px': listWidth , 'min-width.px': listWidth , 'max-width.px': listWidth }">
  <sc-flex fitHeight stretchContent vertical>
    @if (featureMovingOrderActive||featurePlannedTransportsActive) {
      <sc-flex>
        <sc-content-spacer grow></sc-content-spacer>
        @if (featurePlannedTransportsActive) {
          <sc-action-icon (click)="managePlannedAssignments()"
            iconClass="fa-truck-clock"
            [disabled]="selection?.station?.stationType !== stationType.WORKING_AREA || !selection?.station?.stationUsage?.plannedTransportAssignmentPossible">
          </sc-action-icon>
        }
        @if (featureMovingOrderActive) {
          <sc-content-spacer [grow]="false"></sc-content-spacer>
        }
        @if (featureMovingOrderActive) {
          <sc-action-icon (click)="createMovingOrder()"
            [disabled]="!selection?.station?.stationUsage?.createMovementOrderPossible" iconClass="fa-truck-arrow-right">
          </sc-action-icon>
        }
      </sc-flex>
      <sc-content-spacer vertical></sc-content-spacer>
    }
    <sc-flex-fitting-content vertical>
      <sc-scroll-pane>
        @for (transportGroup of transportGroups; track transportGroup) {
          <div class="transport-group">
            @if (transportGroup.transports.length > 0 || transportGroup.key === 'transports') {
              <sc-sub-title>
                <sc-dictionary-label [dictionaryKey]="transportGroup.nameDictionaryKey"></sc-dictionary-label>
              </sc-sub-title>
            }
            @if (transportGroup.transports.length === 0 && transportGroup.key === 'transports') {
              <div class="no-transport-hint"
                >
                <sc-dictionary-label
                dictionaryKey="tmc-yard.ui.control.sac-client.sac-transports.empty"></sc-dictionary-label>
              </div>
            }
            <sc-content-spacer vertical></sc-content-spacer>
            <div class="transport-list">
              @for (transport of transportGroup.transports; track transport) {
                <app-transport-list-entry [transport]="transport" [dashboardContext]="dashboardContext"
                  [selected]="selectedTransportId != null && transport.id === selectedTransportId && selectedTransportGroupKey === transportGroup.key"
                (click)="setSelectedTransport(transportGroup, transport)"></app-transport-list-entry>
                @if (selectedTransportId != null && transport.id === selectedTransportId) {
                  <app-transport-details-list-entry [transport]="transport" [dashboardContext]="dashboardContext"
                  [station]="selection.station" [stationSet]="selection.stationSet"></app-transport-details-list-entry>
                }
                <sc-content-spacer vertical [half]="true"></sc-content-spacer>
              }
            </div>
            <sc-content-spacer vertical></sc-content-spacer>
          </div>
        }
      </sc-scroll-pane>
    </sc-flex-fitting-content>
  </sc-flex>
</div>
